import React, { useEffect } from 'react';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';

import { RolesLowerCase } from '../../../enums';
import styles from './Selector.module.scss';
import RolePlate from '../RolePlate';
import { Checkbox, Radio } from '@material-ui/core';

type TSelector = {
  onSelect: (e: string, i: number) => void;
  index: number;
  defaultValue?: string;
  width?: string;
  disable?: boolean;
  orgType?: 'parent' | 'child';
};

const RoleSelector: React.FC<TSelector> = ({ onSelect, index, defaultValue, width, disable, orgType }) => {
  const [role, setRole] = React.useState('');

  useEffect(() => {
    if (defaultValue) {
      setRole(defaultValue);
    }
  }, [defaultValue]);

  const handleChange = (event: SelectChangeEvent) => {
    if (disable) return;
    setRole(event.target.value);
    onSelect(event.target.value, index);
  };

  return (
    <Box sx={{ minWidth: 120 }}>
      <FormControl
        sx={{
          width: width ? width : '100%',
          border: '1px solid rgba(255, 255, 255, 0.1)',
          bgcolor: '#0a1929',
          '&:focus-within': {
            borderColor: '#39b3ea',
            boxShadow: '0 0 0 3px rgba(57, 179, 234, 0.15)',
          },
          '& .MuiInputLabel-shrink': {
            top: '-8px',
            left: '-13px',
            color: 'white',
            display: 'none',
          },
          borderRadius: '8px',
        }}
        size="small"
        fullWidth
      >
        <InputLabel
          id="demo-select-small"
          sx={{
            color: '#868686',
          }}
        >
          Select User Role
        </InputLabel>
        <Select
          label="Filled"
          inputProps={{
            'aria-label': 'Without label',
            MenuProps: {
              MenuListProps: {
                sx: {
                  backgroundColor: '#0f2336',
                  color: 'white',
                  width: width ? width : '310px',
                },
              },
            },
          }}
          labelId="demo-select-small"
          id="demo-select-small"
          value={role}
          sx={{
            color: 'white',
            '& legend': { display: 'none' },
            '& fieldset': { top: 0 },
            '& .MuiSelect-iconOutlined': {
              color: '#8f9bad',
            },
          }}
          renderValue={() => <>{role}</>}
          onChange={handleChange}
          required
        >
          <MenuItem value={RolesLowerCase.ORGANIZATION_ADMIN}>
            <div className={styles.roleContainer}>
              <div className={styles.leftSide}>
                <Radio
                  style={{ color: role === RolesLowerCase.ORGANIZATION_ADMIN ? '#39b3ea' : '#595D62' }}
                  checked={role === RolesLowerCase.ORGANIZATION_ADMIN}
                />
                <RolePlate className={styles.rolePlate} userRole={RolesLowerCase.ORGANIZATION_ADMIN} />
              </div>
              <div className={styles.roleDescr}>
                Person who manages the organisations and
                <br /> groups with it
              </div>
            </div>
          </MenuItem>

          {orgType !== 'parent' && (
            <MenuItem value={RolesLowerCase.ANALYST}>
              <div className={styles.roleContainer}>
                <div className={styles.leftSide}>
                  <Radio style={{ color: role === 'Analyst' ? '#39b3ea' : '#595D62' }} checked={role === 'Analyst'} />
                  <RolePlate className={styles.rolePlate} userRole={RolesLowerCase.ANALYST} />
                </div>
                <div className={styles.roleDescr}>
                  Person who manages multiple or single groups, <br /> they can upload and share videos
                </div>
              </div>
            </MenuItem>
          )}

          {orgType !== 'parent' && (
            <MenuItem value={RolesLowerCase.VIEWER}>
              <div className={styles.roleContainer}>
                <div className={styles.leftSide}>
                  <Radio style={{ color: role === 'Viewer' ? '#39b3ea' : '#595D62' }} checked={role === 'Viewer'} />
                  <RolePlate className={styles.rolePlate} userRole={RolesLowerCase.VIEWER} />
                </div>
                <div className={styles.roleDescr}>
                  Person who is a participant of a certain group, <br /> they can watch and share parts of videos
                </div>
              </div>
            </MenuItem>
          )}
        </Select>
      </FormControl>
    </Box>
  );
};

export default RoleSelector;
